import api from "../../utils/api";
import { formData } from "../../utils/config";
import { CustomerEmailCode, CustomerToken, Response } from "../../types/types";

export interface CustomerEmailCodeProps {
    email: string
    captcha: string
    shop_id?: number | null
}

export interface CustomerTokenProps {
    email: string
    captcha: string
    shop_id?: number | null
    code: string
    name?: string
    surname?: string
}

export const getCustomerEmailCode = async(data: CustomerEmailCodeProps) => {
  try {
    if(data.shop_id) {
      return await api.post<never, Response<CustomerEmailCode>>(`/customer/auth/email`, formData(data));
    } else {
      throw new Error("shop_id is required");
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}


export const getCustomerToken = async(data: CustomerTokenProps) => {
  try {
    return await api.post<never, Response<CustomerToken>>("customer/auth", formData(data));
  } catch (e) {
    console.error(e);
    throw e;
  }

}
